import { useMemo } from "react";
import NetworksPresenter from "./NetworksPresenter";
import { useTotalFollowers } from "../../api/social";
import { useSocialFollowerArtistFilter } from "@arelia-hooks/artistAccount";

export default function NetworksContainer() {
  const { data = [], isLoading, isError } = useTotalFollowers();
  const filteredData = useSocialFollowerArtistFilter(data);

  const networks = useMemo(
    () => filteredData.map(({ networkName: name, total }) => ({
      name,
      total,
    })).sort((a, b) => b.total - a.total),
    [filteredData]
  );

  return <NetworksPresenter networks={networks} loading={isLoading} error={isError} unconnected={!data.length} />;
}
